import Container from "@mui/material/Container";
import Card from "@mui/material/Card";
import MKBox from "components/MKBox";
import Navbar from "sections/Navbars";
import Footer from "sections/Footers";
import Header from "sections/Headers";
import Articles from "pages/Blog/sections/Articles";
import routes from "routes";
import footerRoutes from "footer.routes";
import bgImage from "assets/imgs/headers/bg-blog.jpg";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import AddCircleOutline from "@mui/icons-material/AddCircleOutline";

import { useState } from "react";
import { useAuth } from "auth/AuthProvider";
import { canEdit } from "auth/roles";
import CreateArticleDialog from "components/CreateArticleDialog";

const breadcrumbs = [
  { label: "Accueil", route: "/" },
  { label: "Blog", route: "/blog" },
];

const Blog = () => {
  const { user } = useAuth();
  const [openCreate, setOpenCreate] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  return (
    <>
      <Navbar routes={routes} sticky />
      <Header bgImage={bgImage} title="Blog" breadcrumbs={breadcrumbs} />
      <Container sx={{ mt: -8, mb: 4 }}>
        <Card sx={{ p: 2, mx: { xs: 2, lg: 3 }, boxShadow: ({ boxShadows: { xxl } }) => xxl }}>
          <Box display="flex" alignItems="center" justifyContent="space-between" mb={1} px={1}>
            <Typography variant="h5">Articles</Typography>
            {canEdit(user) && (
              <Tooltip title="Nouvel article">
                <IconButton onClick={() => setOpenCreate(true)}>
                  <AddCircleOutline />
                </IconButton>
              </Tooltip>
            )}
          </Box>

          <Articles refreshKey={refreshKey} />
        </Card>
      </Container>
      <MKBox pt={6} px={1} mt={6}>
        <Footer content={footerRoutes} />
      </MKBox>

      {canEdit(user) && (
        <CreateArticleDialog
          open={openCreate}
          onClose={() => setOpenCreate(false)}
          onCreated={() => {
            setOpenCreate(false);
            setRefreshKey((k) => k + 1);
          }}
        />
      )}
    </>
  );
};

export default Blog;
